import React, { useState } from "react"

import { useAppDispatch } from "redux/hooks"
import { makeSignPaymentSchedule } from "redux/features/payment_schedule/paymentScheduleSignThunk"
import Spinner from "components/ui/Spinner"
import MobileId from "components/Sign/MobileId"
import { ClientMobileIdFormValues } from "types"
import { MOBILE_ID_SIGN_METHOD } from "config"

type Props = {
  paymentScheduleId: string
  onFailure: () => void
  onSuccess: () => void
}

const MobileIdSignComponent = ({
  paymentScheduleId,
  onFailure,
  onSuccess,
}: Props) => {
  const dispatch = useAppDispatch()

  const [isSubmitting, setSubmitting] = useState(false)

  const handleSubmit = (values: ClientMobileIdFormValues) => {
    setSubmitting(true)

    const { personal_code, phone } = values

    const params = {
      payment_schedule_id: paymentScheduleId,
      signing_method: MOBILE_ID_SIGN_METHOD,
      personal_code,
      phone_number: phone,
    }

    dispatch(makeSignPaymentSchedule(params))
      .then(() => {
        onSuccess()
      })
      .catch(() => {
        onFailure()
      })
      .finally(() => {
        setSubmitting(false)
      })
  }

  return (
    <>
      <Spinner open={isSubmitting} />
      <MobileId onSubmit={handleSubmit} />
    </>
  )
}

export default MobileIdSignComponent
